import { useStore } from 'effector-react'
import React, { useEffect } from 'react'
import { $achievement, achievementMounted, getAchievement } from './model'

export const useAchievementsEdit = () => {
  const achievement = useStore($achievement)
  const loading = useStore(getAchievement.pending)

  useEffect(() => {
    achievementMounted()
  }, [])

  return { achievement, loading }
}
